import { WizardStep } from "@mittwald/flow-components/dist/components/Wizard/components/WizardStep";
import type { FC } from "react";
import React from "react";
import { TariffStepContent } from "./TariffStepContent";
import type { TariffType } from "./utils/TariffUtils";

interface TariffStepProps {
  availableTariffs?: TariffType[];
}

export const TariffStep: FC<TariffStepProps> = (props) => {
  return (
    <WizardStep id="tariff" indicatorText="tariff">
      <TariffStepContent availableTariffs={props.availableTariffs} />
    </WizardStep>
  );
};
